// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AccountBreadcrumbs_wrapper__X0U82","breadcrumbs":"AccountBreadcrumbs_breadcrumbs__sim_Q"};